import { Type } from 'typebox';
export const LibraryLanguages = {
    english: 'en',
    spanish: 'es'
};
export const LibraryLanguage = Type.Enum(LibraryLanguages);
